import { ContextSearchResult } from "store/types/searchResults";

export const mockProducts: ContextSearchResult[] = [
  {
    sid: "s-stp-162",
    name: "Slotted raised countersunk head screws - Product grade A",
    contextName: ".standardParts",
    database: ".standardParts",
    type: "",
    description: "Slotted raised countersunk head screws - Product grade A / Senkkopfschrauben mit Schlitz - Produktklasse A",
    imgUrl: "https://cdn-product-content.traceparts.com/TraceParts/PartFamilies/TRACEPARTS/b2384449-c197-000b-0380-800000000000/Pictures/33-09082018-071625L.gif",
    fullContext: {
      contextName: ".standardParts",
      fullName: "Slotted raised countersunk head screws - Product grade A",
      shortName: "Slotted raised countersunk head screws - Product grade A",
      className: "Bolts, screws, studs",
      centralProductClassification: "",
      hs2017Classification: "",
      group: "ISO 2010"
    }
  },
  {
    sid: "s-stp-161",
    name: "Slotted countersunk flat head screws - Product grade A",
    contextName: ".standardParts",
    database: ".standardParts",
    type: "",
    description: "Slotted countersunk flat head screws - Product grade A / Senkkopfschrauben mit Schlitz - Produktklasse A",
    imgUrl: "https://cdn-product-content.traceparts.com/TraceParts/PartFamilies/TRACEPARTS/b2382211-c197-000b-0480-800000000000/Pictures/33-09082018-062865L.gif",
    fullContext: {
      contextName: ".standardParts",
      fullName: "Slotted countersunk flat head screws - Product grade A",
      shortName: "Slotted countersunk flat head screws - Product grade A",
      className: "Bolts, screws, studs",
      centralProductClassification: "",
      hs2017Classification: "",
      group: "ISO 2009"
    }
  },
  {
    sid: "s-stp-160",
    name: "Slotted pan head screws - Product grade A",
    contextName: ".standardParts",
    database: ".standardParts",
    type: "",
    description: "Slotted pan head screws - Product grade A / Flachkopfschrauben mit Schlitz - Produktklasse A",
    imgUrl: "https://cdn-product-content.traceparts.com/TraceParts/PartFamilies/TRACEPARTS/dd931839-c0ae-000b-0380-800000000000/Pictures/33-08082018-064441L.gif",
    fullContext: {
      contextName: ".standardParts",
      fullName: "Slotted pan head screws - Product grade A",
      shortName: "Slotted pan head screws - Product grade A",
      className: "Bolts, screws, studs",
      centralProductClassification: "",
      hs2017Classification: "",
      group: "ISO 1580"
    }
  }
];
